import React from "react";
import "./CatProgressBar.css";
import "./Indicators.css";
import ProgressBar from "react-bootstrap/ProgressBar";

export default function CatProgressBar({ progress: wpm }) {

  return (
        <div className="CatProgressBar">
          <ProgressBar
            variant={"warning"}
            animated
            now={wpm * 100 / 60}
          />
        </div>
  );
}
